"use strict";

const IncidentsGeoServerLayer = function () {
  const layerName = "incidents";
  const layerKey = "incidentsLayer";

  var createMarkerFunction = function (feature, latlng) {
    return L.marker(latlng, {
      pane: "outfallPane",
      icon: IncidentsIcon.getIncidentsMarkerIcon(
        feature.properties,
        MapFunctions.resizeIconsOnZoom(
          Tree.get("zoomLevel"),
          40,
          20,
          "icon-text-large",
          "icon-text-medium",
          [6, 13, 18, 24, 28, 32, 36, 43],
        ),
      ),
    });
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const incidentsGeoServerLayer = new GeoServerMapLayer(
      layerName,
      layerKey,
      createMarkerFunction,
    );
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, incidentsGeoServerLayer);

    incidentsGeoServerLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    incidentsGeoServerLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
    loadGlobalListeners();
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var organizeLayerData = function (layerData) {
    return layerData.map(function (data) {
      return getOrganizedProperties(data.properties, data.geometry);
    });
  };

  var getOrganizedProperties = function (data, geometry) {
    const properties = {
      geometry: geometry,
      id: data.id,
      groupId: data.group_id,
      incidentName: data.incident_name,
      address: data.address,
      city: data.city,
      zip: data.zip,
      requestedDate: data.requested_date,
      requestingType: data.requesting_type,
      requestingAffiliation: data.requesting_affiliation,
      partnerAgency: data.partner_agency,
      incidentType: data.incident_type,
      incidentNotes: data.incident_notes,
      responsiblePartyIdentified: data.responsible_party_identified,
      responsiblePartyName: data.responsible_party_name,
      responsiblePartyPhone: data.responsible_party_phone,
      responsiblePartyAddress: data.responsible_party_address,
      drainsToRw: data.drains_to_rw,
      drainsToC: data.drains_to_c,
      catchmentName: data.catchment_name,
      mileMarker: data.mile_marker,
      highwayName: data.highway_assignment,
      lastInvestigationId: data.last_investigation_id,
      closeOutInvestigation: data.close_out_investigation,
      closeOutReason: data.close_out_reason,
      investigationDate: data.investigation_date,
      investigationStartTime: data.investigation_start_time,
      investigationEndTime: data.investigation_end_time,
      illicitFlowMaterialActivity: data.illicit_flow_material_activity,
      activityType: JSON.parse(data.activity_types || "[]"),
      investigationIncidentType: data.investigation_incident_type,
      incidentTypeLocation: data.incident_type_location,
      enforcementIssued: data.enforcement_issued,
      followUpNeeded: data.follow_up_needed,
      followUpDate: data.follow_up_date,
      reachedStormDrain: data.reached_storm_drain,
      incidentStatus: data.incident_status,
      openEnforcements: data.open_enforcements,
      canIssueEnforcement: ToolSettings.getSetting("permissions", "can_issue_incident_enforcement"),
      canCreateIncidentInvestigation: ToolSettings.getSetting(
        "permissions",
        "can_create_incident_investigation",
      ),
      ...GeoServerLayerFunctions.prepareToDoData(data, {
        incident_new: "incidentNew",
        incident_open: "incidentOpen",
        incident_reinvestigation: "incidentReinvestigation",
        incident_maintenance_response: "incidentMaintenanceResponse",
        incident_flagged_for_new_enforcement: "incidentFlaggedForNewEnforcement",
        incident_open_enforcement: "incidentOpenEnforcement",
        incident_recommended_action: "incidentRecommendedAction",
      }),
    };

    properties.tableIcon = IncidentsIcon.getIncidentsIconClass(
      properties.incidentStatus,
      properties.openEnforcements,
    );

    return properties;
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await GeoServerLayerFunctions.getFeaturesForLayer(
      layerName,
      onlineFiltering,
      loadingScreen,
    );
    return organizeLayerData(data);
  };

  var loadGlobalListeners = function () {
    $("body").off("click", ".js-edit-incident-enforcement", editEnforcementAction);
    $("body").on("click", ".js-edit-incident-enforcement", editEnforcementAction);

    $("body").off("click", ".js-view-incident-enforcement", viewEnforcementAction);
    $("body").on("click", ".js-view-incident-enforcement", viewEnforcementAction);
  };

  var editEnforcementAction = function () {
    const id = $(this).data("id");
    const recommendedAction = $(this).data("recommended-action");
    IncidentEnforcementController.editEnforcementAction(
      id,
      null,
      {},
      recommendedAction ? { escalationAction: recommendedAction } : {},
    );
  };

  var viewEnforcementAction = function () {
    const id = $(this).data("id");
    IncidentEnforcementController.viewEnforcementAction(id);
  };

  var updateLegendByActiveTab = function (activeTab) {
    $(".legend-incidents .idde-incident-closed")
      .parents("tr")
      .toggle(activeTab !== "todo");
  };

  var getOfflineData = function (id) {
    return ResourceController.get("incidents").getById(id);
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    invalidateLayerData,
    organizeLayerData,
    getLayerData,
    getOfflineData,
    updateLegendByActiveTab,
  };
};

module.exports = IncidentsGeoServerLayer();

const GeoServerLayerFunctions = require("../../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../../mapFunctions/geoServerMapLayer");
const IncidentsIcon = require("./incidentsIcon");
const IncidentEnforcementController = require("../incidentEnforcement/incidentEnforcementController");
const MapFunctions = require("../../mapFunctions/mapFunctions");
const ResourceController = require("../../offline/resourceController");
const ToolSettings = require("../../settings/toolSettings");
const Tree = require("../../tree");
